'use strict';

var Sugar = require('sugar-core'),
    createDate = require('./internal/createDate');

Sugar.Date.defineInstance({

  'isBefore': function(date, d, margin) {
    return date.getTime() < createDate(d).getTime() + (margin || 0);
  }

});

module.exports = Sugar.Date.isBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isBefore.js
// module id = 301
// module chunks = 0